import { TypeSpecifierAggregator } from './TypeSpecifier';
import { visitObject } from '@Common/Helpers/CommonUtils';
import { toServerTime } from '@Common/Helpers/ServerTime';

function internalGetRequestObject<T>(component: T, visitValue?: (data: any) => void): T {
    component = _.cloneDeep(component);
    visitObject(
        component,
        value => {
            if (Object.prototype.toString.call(value) === '[object Date]') {
                value.setTime(toServerTime(value).getTime());
            }
            visitValue && visitValue(value);
        },
        null,
        !!visitObject
    );

    return component;
}

export function getRequestObject<T>(component: T): T {
    return internalGetRequestObject(component);
}

export function getRequestObjectWithSpecTypes<T>(component: T, projectId: string): T {
    const specifier = new TypeSpecifierAggregator(projectId);
    const visitValue = data => specifier.canSpecify(data) && specifier.specify(data);
    return internalGetRequestObject(component, visitValue);
}
